import store from '@/store';
import userService from '@/services/users.service';

export const getIsBankAvailableByIban = (ibanCode, yoIdBanksAvailable) => {
    if (!ibanCode) return false;
    if (!yoIdBanksAvailable || yoIdBanksAvailable.length === 0) return true;

    const ibanBankCodePrefix = ibanCode
        .replace(/\s+/g, '')
        .slice(4, 8)
        .toUpperCase()
        .replace(/^0+/, '');
    const bankMatch = yoIdBanksAvailable.find(
        bank => bank.code.toUpperCase() === ibanBankCodePrefix
    );

    if (!bankMatch) return false;

    const isBankAvailable = bankMatch.status.toUpperCase() === 'DISPONIBLE';

    return isBankAvailable;
};

export const getYoIdBanksAvailable = async () => {
    const hasYoIdEnabled = store.getters.getHasYoidEnabled;
    if (!hasYoIdEnabled) return [];

    const response = await userService.getConfig({}, 'YOID_BANKS_AVAILABLE');

    if (
        !response ||
        !response.data ||
        !response.data.configuration ||
        !response.data.configuration.value
    )
        return [];

    const banksAvailable = JSON.parse(response.data.configuration.value);

    return banksAvailable;
};
